/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetRecentMeshRunsQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  creditFacilitySlugsToHide?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  startDate?: Types.Maybe<Types.Scalars['JSDate']>;
  endDate?: Types.Maybe<Types.Scalars['JSDate']>;
}>;


export type GetRecentMeshRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { meshRuns: Types.QueryGQLType['getRecentMeshRuns'] }
);

export type GetLatestMeshRunQueryVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
}>;


export type GetLatestMeshRunQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<Types.QueryGQLType, 'getLatestMeshRun'>
);

export type GetAllRecentMeshRunsQueryVariablesGQLType = Types.Exact<{
  startDate?: Types.Maybe<Types.Scalars['JSDate']>;
  endDate?: Types.Maybe<Types.Scalars['JSDate']>;
  limit?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type GetAllRecentMeshRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { allMeshRuns: Types.QueryGQLType['getAllRecentMeshRuns'] }
);

export type GetImplementationPipelineRunsQueryVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
  startDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  endDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
}>;


export type GetImplementationPipelineRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRuns: Array<(
    { __typename?: 'PipelineRun' }
    & Pick<Types.PipelineRunGQLType, 'reportingDate' | 'fileVersion'>
  )> }
);

export type GetBorrowerPipelineRunsQueryVariablesGQLType = Types.Exact<{
  borrowerOrganizationId: Types.Scalars['UUID'];
  startDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  endDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
}>;


export type GetBorrowerPipelineRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRuns: Array<(
    { __typename?: 'PipelineRun' }
    & Pick<Types.PipelineRunGQLType, 'reportingDate' | 'fileVersion'>
  )> }
);

export type GetMaybeCompleteMeshRunRecordQueryVariablesGQLType = Types.Exact<{
  meshRunId?: Types.Maybe<Types.Scalars['String']>;
  meshRunParams?: Types.Maybe<Types.MeshRunParamsGQLType>;
}>;


export type GetMaybeCompleteMeshRunRecordQueryGQLType = (
  { __typename?: 'Query' }
  & { maybeCompleteMeshRunRecord: Types.QueryGQLType['getCompleteMeshRunRecordIfAvailable'] }
);

export type GetMeshDocumentQueryVariablesGQLType = Types.Exact<{
  meshDocumentId: Types.Scalars['String'];
}>;


export type GetMeshDocumentQueryGQLType = (
  { __typename?: 'Query' }
  & { meshDocument: Types.QueryGQLType['getMeshDocument'] }
);

export type GetLatestMeshDocumentMetadataQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  creditFacilitySlugsToHide?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type GetLatestMeshDocumentMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { latestMeshDocumentMetadata: Types.QueryGQLType['getLatestMeshDocumentMetadata'] }
);

export type GetDataPipelineDownloadSignedUrlQueryVariablesGQLType = Types.Exact<{
  serializedParams: Types.Scalars['String'];
}>;


export type GetDataPipelineDownloadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<Types.UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);

export type GetPipelineRunInputsQueryVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
  reportingDate: Types.Scalars['FullDateStr'];
  artifactSlugs: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type GetPipelineRunInputsQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRunInputs: Array<(
    { __typename?: 'PipelineRunInputs' }
    & Pick<Types.PipelineRunInputsGQLType, 'pipelineRunId' | 'reportingDate' | 'fileVersion' | 'createdAt' | 'isLatest' | 'isStale'>
    & { inputs: Array<(
      { __typename?: 'PipelineRunInput' }
      & Pick<Types.PipelineRunInputGQLType, 'artifactSlug' | 'status' | 'uploadedAt'>
    )> }
  )> }
);

export type CreatePipelineSubmissionMutationVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
  reportingDate: Types.Scalars['FullDateStr'];
  fileVersion: Types.Scalars['Int'];
  newRun: Types.Scalars['Boolean'];
  inputs: Array<Types.PipelineSubmissionInputGQLType> | Types.PipelineSubmissionInputGQLType;
}>;


export type CreatePipelineSubmissionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createPipelineSubmission: (
    { __typename?: 'PipelineSubmission' }
    & Pick<Types.PipelineSubmissionGQLType, 'fileVersion'>
    & { uploads: Array<(
      { __typename?: 'PipelineSubmissionUpload' }
      & Pick<Types.PipelineSubmissionUploadGQLType, 'artifactSlug' | 'url'>
      & { fields: Array<(
        { __typename?: 'PresignedPostField' }
        & Pick<Types.PresignedPostFieldGQLType, 'name' | 'value'>
      )> }
    )> }
  ) }
);


export const GetRecentMeshRunsDocumentGQLType = gql`
    query GetRecentMeshRuns($organizationId: UUID!, $creditFacilitySlugsToHide: [String!], $startDate: JSDate, $endDate: JSDate) {
  meshRuns: getRecentMeshRuns(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
    startDate: $startDate
    endDate: $endDate
  )
}
    `;

/**
 * __useGetRecentMeshRunsQuery__
 *
 * To run a query within a React component, call `useGetRecentMeshRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentMeshRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentMeshRunsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetRecentMeshRunsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>(GetRecentMeshRunsDocumentGQLType, options);
      }
export function useGetRecentMeshRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>(GetRecentMeshRunsDocumentGQLType, options);
        }
export type GetRecentMeshRunsQueryHookResult = ReturnType<typeof useGetRecentMeshRunsQuery>;
export type GetRecentMeshRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRecentMeshRunsLazyQueryGQLType>;
export type GetRecentMeshRunsQueryResultGQLType = Apollo.QueryResult<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>;
export const GetLatestMeshRunDocumentGQLType = gql`
    query GetLatestMeshRun($implementationId: UUID!) {
  getLatestMeshRun(implementationId: $implementationId)
}
    `;

/**
 * __useGetLatestMeshRunQuery__
 *
 * To run a query within a React component, call `useGetLatestMeshRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMeshRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMeshRunQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetLatestMeshRunQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>(GetLatestMeshRunDocumentGQLType, options);
      }
export function useGetLatestMeshRunLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>(GetLatestMeshRunDocumentGQLType, options);
        }
export type GetLatestMeshRunQueryHookResult = ReturnType<typeof useGetLatestMeshRunQuery>;
export type GetLatestMeshRunLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestMeshRunLazyQueryGQLType>;
export type GetLatestMeshRunQueryResultGQLType = Apollo.QueryResult<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>;
export const GetAllRecentMeshRunsDocumentGQLType = gql`
    query GetAllRecentMeshRuns($startDate: JSDate, $endDate: JSDate, $limit: Int) {
  allMeshRuns: getAllRecentMeshRuns(
    startDate: $startDate
    endDate: $endDate
    limit: $limit
  )
}
    `;

/**
 * __useGetAllRecentMeshRunsQuery__
 *
 * To run a query within a React component, call `useGetAllRecentMeshRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRecentMeshRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRecentMeshRunsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllRecentMeshRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>(GetAllRecentMeshRunsDocumentGQLType, options);
      }
export function useGetAllRecentMeshRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>(GetAllRecentMeshRunsDocumentGQLType, options);
        }
export type GetAllRecentMeshRunsQueryHookResult = ReturnType<typeof useGetAllRecentMeshRunsQuery>;
export type GetAllRecentMeshRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAllRecentMeshRunsLazyQueryGQLType>;
export type GetAllRecentMeshRunsQueryResultGQLType = Apollo.QueryResult<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>;
export const GetImplementationPipelineRunsDocumentGQLType = gql`
    query GetImplementationPipelineRuns($implementationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr) {
  getPipelineRuns(
    implementationId: $implementationId
    startDate: $startDate
    endDate: $endDate
  ) {
    reportingDate
    fileVersion
  }
}
    `;

/**
 * __useGetImplementationPipelineRunsQuery__
 *
 * To run a query within a React component, call `useGetImplementationPipelineRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImplementationPipelineRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImplementationPipelineRunsQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetImplementationPipelineRunsQuery(baseOptions: Apollo.QueryHookOptions<GetImplementationPipelineRunsQueryGQLType, GetImplementationPipelineRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImplementationPipelineRunsQueryGQLType, GetImplementationPipelineRunsQueryVariablesGQLType>(GetImplementationPipelineRunsDocumentGQLType, options);
      }
export function useGetImplementationPipelineRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetImplementationPipelineRunsQueryGQLType, GetImplementationPipelineRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImplementationPipelineRunsQueryGQLType, GetImplementationPipelineRunsQueryVariablesGQLType>(GetImplementationPipelineRunsDocumentGQLType, options);
        }
export type GetImplementationPipelineRunsQueryHookResult = ReturnType<typeof useGetImplementationPipelineRunsQuery>;
export type GetImplementationPipelineRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetImplementationPipelineRunsLazyQueryGQLType>;
export type GetImplementationPipelineRunsQueryResultGQLType = Apollo.QueryResult<GetImplementationPipelineRunsQueryGQLType, GetImplementationPipelineRunsQueryVariablesGQLType>;
export const GetBorrowerPipelineRunsDocumentGQLType = gql`
    query GetBorrowerPipelineRuns($borrowerOrganizationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr) {
  getPipelineRuns(
    organizationId: $borrowerOrganizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    reportingDate
    fileVersion
  }
}
    `;

/**
 * __useGetBorrowerPipelineRunsQuery__
 *
 * To run a query within a React component, call `useGetBorrowerPipelineRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowerPipelineRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowerPipelineRunsQuery({
 *   variables: {
 *      borrowerOrganizationId: // value for 'borrowerOrganizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetBorrowerPipelineRunsQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>(GetBorrowerPipelineRunsDocumentGQLType, options);
      }
export function useGetBorrowerPipelineRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>(GetBorrowerPipelineRunsDocumentGQLType, options);
        }
export type GetBorrowerPipelineRunsQueryHookResult = ReturnType<typeof useGetBorrowerPipelineRunsQuery>;
export type GetBorrowerPipelineRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowerPipelineRunsLazyQueryGQLType>;
export type GetBorrowerPipelineRunsQueryResultGQLType = Apollo.QueryResult<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>;
export const GetMaybeCompleteMeshRunRecordDocumentGQLType = gql`
    query GetMaybeCompleteMeshRunRecord($meshRunId: String, $meshRunParams: MeshRunParams) {
  maybeCompleteMeshRunRecord: getCompleteMeshRunRecordIfAvailable(
    meshRunId: $meshRunId
    meshRunParams: $meshRunParams
  )
}
    `;

/**
 * __useGetMaybeCompleteMeshRunRecordQuery__
 *
 * To run a query within a React component, call `useGetMaybeCompleteMeshRunRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaybeCompleteMeshRunRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaybeCompleteMeshRunRecordQuery({
 *   variables: {
 *      meshRunId: // value for 'meshRunId'
 *      meshRunParams: // value for 'meshRunParams'
 *   },
 * });
 */
export function useGetMaybeCompleteMeshRunRecordQuery(baseOptions?: Apollo.QueryHookOptions<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>(GetMaybeCompleteMeshRunRecordDocumentGQLType, options);
      }
export function useGetMaybeCompleteMeshRunRecordLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>(GetMaybeCompleteMeshRunRecordDocumentGQLType, options);
        }
export type GetMaybeCompleteMeshRunRecordQueryHookResult = ReturnType<typeof useGetMaybeCompleteMeshRunRecordQuery>;
export type GetMaybeCompleteMeshRunRecordLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMaybeCompleteMeshRunRecordLazyQueryGQLType>;
export type GetMaybeCompleteMeshRunRecordQueryResultGQLType = Apollo.QueryResult<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>;
export const GetMeshDocumentDocumentGQLType = gql`
    query GetMeshDocument($meshDocumentId: String!) {
  meshDocument: getMeshDocument(meshDocumentId: $meshDocumentId)
}
    `;

/**
 * __useGetMeshDocumentQuery__
 *
 * To run a query within a React component, call `useGetMeshDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeshDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeshDocumentQuery({
 *   variables: {
 *      meshDocumentId: // value for 'meshDocumentId'
 *   },
 * });
 */
export function useGetMeshDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>(GetMeshDocumentDocumentGQLType, options);
      }
export function useGetMeshDocumentLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>(GetMeshDocumentDocumentGQLType, options);
        }
export type GetMeshDocumentQueryHookResult = ReturnType<typeof useGetMeshDocumentQuery>;
export type GetMeshDocumentLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMeshDocumentLazyQueryGQLType>;
export type GetMeshDocumentQueryResultGQLType = Apollo.QueryResult<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>;
export const GetLatestMeshDocumentMetadataDocumentGQLType = gql`
    query GetLatestMeshDocumentMetadata($organizationId: UUID!, $creditFacilitySlugsToHide: [String!]) {
  latestMeshDocumentMetadata: getLatestMeshDocumentMetadata(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
  )
}
    `;

/**
 * __useGetLatestMeshDocumentMetadataQuery__
 *
 * To run a query within a React component, call `useGetLatestMeshDocumentMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMeshDocumentMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMeshDocumentMetadataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *   },
 * });
 */
export function useGetLatestMeshDocumentMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>(GetLatestMeshDocumentMetadataDocumentGQLType, options);
      }
export function useGetLatestMeshDocumentMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>(GetLatestMeshDocumentMetadataDocumentGQLType, options);
        }
export type GetLatestMeshDocumentMetadataQueryHookResult = ReturnType<typeof useGetLatestMeshDocumentMetadataQuery>;
export type GetLatestMeshDocumentMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestMeshDocumentMetadataLazyQueryGQLType>;
export type GetLatestMeshDocumentMetadataQueryResultGQLType = Apollo.QueryResult<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>;
export const GetDataPipelineDownloadSignedUrlDocumentGQLType = gql`
    query getDataPipelineDownloadSignedUrl($serializedParams: String!) {
  downloadUrls: getSignedDownloadUrls(
    feature: "dataPipelineInstanceRecord"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetDataPipelineDownloadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetDataPipelineDownloadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPipelineDownloadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPipelineDownloadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDataPipelineDownloadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>(GetDataPipelineDownloadSignedUrlDocumentGQLType, options);
      }
export function useGetDataPipelineDownloadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>(GetDataPipelineDownloadSignedUrlDocumentGQLType, options);
        }
export type GetDataPipelineDownloadSignedUrlQueryHookResult = ReturnType<typeof useGetDataPipelineDownloadSignedUrlQuery>;
export type GetDataPipelineDownloadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDataPipelineDownloadSignedUrlLazyQueryGQLType>;
export type GetDataPipelineDownloadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>;
export const GetPipelineRunInputsDocumentGQLType = gql`
    query GetPipelineRunInputs($implementationId: UUID!, $reportingDate: FullDateStr!, $artifactSlugs: [String!]!) {
  getPipelineRunInputs(
    implementationId: $implementationId
    reportingDate: $reportingDate
    artifactSlugs: $artifactSlugs
  ) {
    pipelineRunId
    reportingDate
    fileVersion
    createdAt
    isLatest
    isStale
    inputs {
      artifactSlug
      status
      uploadedAt
    }
  }
}
    `;

/**
 * __useGetPipelineRunInputsQuery__
 *
 * To run a query within a React component, call `useGetPipelineRunInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineRunInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineRunInputsQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      reportingDate: // value for 'reportingDate'
 *      artifactSlugs: // value for 'artifactSlugs'
 *   },
 * });
 */
export function useGetPipelineRunInputsQuery(baseOptions: Apollo.QueryHookOptions<GetPipelineRunInputsQueryGQLType, GetPipelineRunInputsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPipelineRunInputsQueryGQLType, GetPipelineRunInputsQueryVariablesGQLType>(GetPipelineRunInputsDocumentGQLType, options);
      }
export function useGetPipelineRunInputsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPipelineRunInputsQueryGQLType, GetPipelineRunInputsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPipelineRunInputsQueryGQLType, GetPipelineRunInputsQueryVariablesGQLType>(GetPipelineRunInputsDocumentGQLType, options);
        }
export type GetPipelineRunInputsQueryHookResult = ReturnType<typeof useGetPipelineRunInputsQuery>;
export type GetPipelineRunInputsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPipelineRunInputsLazyQueryGQLType>;
export type GetPipelineRunInputsQueryResultGQLType = Apollo.QueryResult<GetPipelineRunInputsQueryGQLType, GetPipelineRunInputsQueryVariablesGQLType>;
export const CreatePipelineSubmissionDocumentGQLType = gql`
    mutation CreatePipelineSubmission($implementationId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!, $newRun: Boolean!, $inputs: [PipelineSubmissionInput!]!) {
  createPipelineSubmission(
    implementationId: $implementationId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    newRun: $newRun
    inputs: $inputs
  ) {
    fileVersion
    uploads {
      artifactSlug
      url
      fields {
        name
        value
      }
    }
  }
}
    `;
export type CreatePipelineSubmissionMutationFnGQLType = Apollo.MutationFunction<CreatePipelineSubmissionMutationGQLType, CreatePipelineSubmissionMutationVariablesGQLType>;

/**
 * __useCreatePipelineSubmissionMutation__
 *
 * To run a mutation, you first call `useCreatePipelineSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePipelineSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPipelineSubmissionMutation, { data, loading, error }] = useCreatePipelineSubmissionMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      newRun: // value for 'newRun'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreatePipelineSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePipelineSubmissionMutationGQLType, CreatePipelineSubmissionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePipelineSubmissionMutationGQLType, CreatePipelineSubmissionMutationVariablesGQLType>(CreatePipelineSubmissionDocumentGQLType, options);
      }
export type CreatePipelineSubmissionMutationHookResult = ReturnType<typeof useCreatePipelineSubmissionMutation>;
export type CreatePipelineSubmissionMutationResultGQLType = Apollo.MutationResult<CreatePipelineSubmissionMutationGQLType>;
export type CreatePipelineSubmissionMutationOptionsGQLType = Apollo.BaseMutationOptions<CreatePipelineSubmissionMutationGQLType, CreatePipelineSubmissionMutationVariablesGQLType>;